<div class="topbar-user-menu">
  <button
    type="button"
    class="topbar-user-menu__trigger"
    (click)="toggleMenu($event)"
    [attr.aria-expanded]="menuVisible"
    aria-haspopup="true"
    aria-label="Abrir menu do usuário"
  >
    <span class="topbar-user-menu__avatar">{{ userInitials }}</span>
    <i
      class="pi"
      [ngClass]="menuVisible ? 'pi-chevron-up' : 'pi-chevron-down'"
    ></i>
  </button>

  <div class="topbar-user-menu__panel" *ngIf="menuVisible">
    <div class="topbar-user-menu__header">
      <p class="topbar-user-menu__name">{{ userName }}</p>
      <p class="topbar-user-menu__email" *ngIf="userEmail">{{ userEmail }}</p>
    </div>

    <button
      type="button"
      class="topbar-user-menu__item"
      (click)="onAccountClick($event)"
    >
      <i class="pi pi-user"></i>
      <span>{{ languageKey.ACCOUNT | translateKey }}</span>
    </button>

    <button
      type="button"
      class="topbar-user-menu__item"
      (click)="onHelpClick($event)"
    >
      <i class="pi pi-question-circle"></i>
      <span>{{ languageKey.HELP | translateKey }}</span>
    </button>

    <button
      type="button"
      class="topbar-user-menu__item topbar-user-menu__item--danger"
      (click)="onLogoutClick($event)"
    >
      <i class="pi pi-sign-out"></i>
      <span>{{ languageKey.LOGOUT | translateKey }}</span>
    </button>
  </div>
</div>
